/* eslint-disable class-methods-use-this */
class DragOverlay {
  constructor() {
    this.offset = 0;
    this.timeoutID = null;
  }

  animate() {
    this.offset += 1;
    if (this.offset > 16) {
      this.offset = 0;
    }
    this.draw();
    this.timeoutID = setTimeout(
      function animateTimeout() {
        this.animate();
      }.bind(this),
      40
    );
  }

  createContext() {
    const ctx = this.highlightEl.getContext("2d");
    ctx.fillStyle = "rgba(0,0,0,0.6)";
    ctx.strokeStyle = "#ffffff";
    return ctx;
  }

  createOverLay() {
    const overlayEl = this.iframeDocument.createElement("div");
    overlayEl.id = "highlight-container";
    overlayEl.style.position = "absolute";
    overlayEl.style.top = 0;
    overlayEl.style.left = 0;
    overlayEl.style.width = "100%";
    overlayEl.style.height = "100%";
    overlayEl.style.pointerEvents = "none";
    overlayEl.innerHTML =
      '<canvas id="highlight" style="width:100%; height:100%;pointer-events:none;" />';
    return overlayEl;
  }

  destroy() {
    if (this.timeoutID) {
      clearTimeout(this.timeoutID);
      this.timeoutID = null;
    }

    if (this.overlayEl) {
      this.overlayEl.remove();
    }
  }

  draw() {
    this.context.clearRect(
      0,
      0,
      this.highlightEl.width,
      this.highlightEl.height
    );
    this.context.fillRect(
      0,
      0,
      this.highlightEl.width,
      this.highlightEl.height
    );
    this.iframeDocument
      .querySelectorAll(".content-section .container")
      .forEach(cc => {
        const obj = cc.getBoundingClientRect();
        this.context.clearRect(
          obj.x,
          this.iframeWindow.scrollY + obj.y,
          obj.width,
          obj.height
        );
        this.context.setLineDash([4, 4]);
        this.context.lineDashOffset = -this.offset;
        this.context.strokeRect(
          obj.x - 1,
          this.iframeWindow.scrollY + obj.y - 1,
          obj.width + 2,
          obj.height + 2
        );
      });
  }

  getIframeDocument() {
    return this.iframeWindow.document;
  }

  getIframeWindow() {
    return document.querySelector("iframe.editor-frame").contentWindow;
  }

  getHighlightElement() {
    const el = this.iframeDocument.getElementById("highlight");
    const { width, height } = this.overlayEl.getBoundingClientRect();
    el.width = width;
    el.height = height;
    return el;
  }

  start() {
    this.iframeWindow = this.getIframeWindow();
    this.iframeDocument = this.getIframeDocument();
    this.overlayEl = this.createOverLay();
    this.iframeDocument.body.appendChild(this.overlayEl);
    this.highlightEl = this.getHighlightElement();
    this.context = this.createContext();
    this.animate();
  }
}

export default DragOverlay;
